import {Card, FormControl, Separator} from 'platform/components';
import {VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import {TenantResponseBody} from '@dms/api/shared';
import {GetArticleResponse} from '@dms/api/warehouse';

import {suffixTestId, TestIdProps} from 'shared/web';

import {ArticleDetailForm} from '../types/ArticleDetailFormSchema';
import {PricesTabPricesForm} from './PricesTabPricesForm';
import {PricesTabSettingsForm} from './PricesTabSettingsForm';

interface OverviewPricesTabProps extends TestIdProps {
  article: GetArticleResponse;
  tenant: TenantResponseBody;
  control: FormControl<ArticleDetailForm>;
  formApi: UseFormReturn<ArticleDetailForm>;
  isPricingDisabled: boolean;
}

export function PricesTab(props: OverviewPricesTabProps) {
  return (
    <Card>
      <VStack data-testid={suffixTestId('articleCatalogs', props)} width="100%">
        <PricesTabSettingsForm
          control={props.control}
          isPricingDisabled={props.isPricingDisabled}
        />
        <Separator />
        <PricesTabPricesForm
          control={props.control}
          article={props.article}
          tenant={props.tenant}
          isPricingDisabled={props.isPricingDisabled}
        />
      </VStack>
    </Card>
  );
}
